module.exports = __webpack_public_path__ + "img/main06.8ce60e89.jpg";